import { CompetenciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCompetencies = () => {
  const { data, loading } = useQuery(CompetenciesDocument)

  return {
    loading,
    competencies: data ? data.competencies.competencies : undefined,
  }
}
